import { _API, _AXIOS_HELPER, _HEADER } from '@/static';
import * as ENUM from "@/enum/lib";
export default {
    createMeetingFromServer( data ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/meeting/chime/createMeeting';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } );
    },
    closeMeetingFromServer( data ) {
        return new Promise(((resolve, reject) => {
            const url = _API + '/meeting/chime/closeMeeting';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        }));
    }

}
